import { RouterModule, Routes } from '@angular/router';
import { HomeComponent, LoginComponent, ServiciosComponent,
        ServicioComponent, UsuariosComponent, UsuarioComponent,
        SeguimientoComponent, NotificacionesComponent, RegistroComponent} from "./components/index.component";

const APP_ROUTES: Routes = [
  { path: 'home', component: HomeComponent },
  { path: 'login', component: LoginComponent },
  { path: 'servicios', component: ServiciosComponent },
  { path: 'servicio/:id', component: ServicioComponent },
  { path: 'usuarios', component: UsuariosComponent },
  { path: 'usuario/:id', component: UsuarioComponent },
  { path: 'seguimiento/:id', component: SeguimientoComponent },
  { path: 'notificaciones', component: NotificacionesComponent },
  { path: 'registro/:id', component: RegistroComponent },
  { path: '**', pathMatch: 'full', redirectTo: 'home' }
];

export const APP_ROUTING = RouterModule.forRoot(APP_ROUTES, { useHash:true });



// WEBPACK FOOTER //
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/app.routing.ts